import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api, { formatErr } from "@/lib/api";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (newPw.length < 6) return toast.error("New password must be 6+ characters");
    if (newPw !== confirm) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { old_password: oldPw, new_password: newPw });
      toast.success("Password changed successfully");
      setOldPw(""); setNewPw(""); setConfirm("");
      onOpenChange(false);
    } catch (e) {
      toast.error(formatErr(e.response?.data?.detail) || "Failed");
    }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="change-pw-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif-display erp-text-primary">Change Password</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs font-semibold">Current Password</Label>
            <Input type="password" value={oldPw} onChange={(e) => setOldPw(e.target.value)} className="h-9" data-testid="cp-old" />
          </div>
          <div>
            <Label className="text-xs font-semibold">New Password</Label>
            <Input type="password" value={newPw} onChange={(e) => setNewPw(e.target.value)} className="h-9" data-testid="cp-new" />
          </div>
          <div>
            <Label className="text-xs font-semibold">Confirm New Password</Label>
            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="h-9" data-testid="cp-confirm" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={submit} disabled={busy} className="erp-primary" data-testid="cp-submit">
            {busy ? "Updating…" : "Update Password"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
